<template>
  <div class="container-fluid">
    <div class="row">
      <nav
        id="sidebarMenu"
        class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse"
        style="overflow: auto;"
      >
        <div class="position-sticky pt-3">
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-2 mb-1 text-muted"
          >
            <span>RATING ENGINE</span>
          </h6>
          <ul class="nav flex-column mb-2 px-4">
            <li class="nav-item">
              <a class="nav-link" href="/insurers">
                <span data-feather="file-text"></span>
                Insurers
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/calculators">
                <span data-feather="file-text"></span>
                Calculators
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <span data-feather="file-text"></span>
                Testing
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <span data-feather="file-text"></span>
                Logs
              </a>
            </li>
          </ul>
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-3 mb-1 text-muted"
          >
            <span>MAPPING ENGINE</span>
          </h6>
          <ul class="nav flex-column mb-2 px-4">
            <li class="nav-item">
              <a class="nav-link" href="/sourcefields">
                <span data-feather="file-text"></span>
                Source Fields
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/map">
                <span data-feather="file-text"></span>
                Insurer Translation Map
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/lookup">
                <span data-feather="file-text"></span>
                Lookup Tables
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/rulesets">
                <span data-feather="file-text"></span>
                Rulesets
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="/outboundfields">
                <span data-feather="file-text"></span>
                Outbound Fields
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/outboundrulesets">
                <span data-feather="file-text"></span>
                Outbound Rulesets
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <span data-feather="file-text"></span>
                Testing
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <span data-feather="file-text"></span>
                Logs
              </a>
            </li>
          </ul>
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-3 mb-1 text-muted"
          >
            <span>ADMINISTRATION</span>
          </h6>
          <ul class="nav flex-column mb-2 px-4">
            <li class="nav-item">
              <a class="nav-link" href="/users">
                <span data-feather="file-text"></span>
                User Accounts
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <span data-feather="file-text"></span>
                Logs
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <main class="col-md-9 ms-sm-auto col-lg-10 px-md-5" id="main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style>
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
body {
  font-size: 0.875rem;
}

.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;

  left: 0;
  z-index: 100;
  padding: 48px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

@media (max-width: 767.98px) {
  .sidebar {
    top: 2rem;
  }
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
  padding: 0.5rem 0.7rem;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #727272;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1rem;
}

.navbar .navbar-toggler {
  top: 0.25rem;
  right: 1rem;
}

.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

.dropdown-menu {
  min-width: 8rem;
}
</style>
